var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.$route('subscriptions.customers.invoices', _vm.uid)}},[_vm._v("\n    "+_vm._s(_vm.total)+"\n    "),_c('span',{staticClass:"d-none d-xl-inline-block"},[_vm._v(" "+_vm._s(_vm.__('subscriptions.invoices')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }